import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const SITE_TITLE = "30 Minute Phone Call";

export default function DocumentTitle() {
  const location = useLocation();

  useEffect(() => {
    document.title = SITE_TITLE;
  }, [location.pathname]);

  return null;
}
